var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2024 1.29797C16.6907 0.786996 15.9971 0.5 15.2739 0.5C14.5507 0.5 13.8571 0.786996 13.3454 1.29797L1.10278 13.5408C0.75219 13.8894 0.47421 14.3041 0.284923 14.7609C0.0956352 15.2176 -0.00120286 15.7074 1.1277e-05 16.2018V17.7472C1.1277e-05 17.9469 0.0793178 18.1383 0.220484 18.2795C0.361651 18.4207 0.553114 18.5 0.752753 18.5H2.29813C2.79251 18.5014 3.28224 18.4047 3.739 18.2155C4.19575 18.0264 4.61045 17.7485 4.95907 17.3979L17.2024 5.15435C17.7132 4.64262 18 3.94916 18 3.22616C18 2.50316 17.7132 1.8097 17.2024 1.29797ZM3.8947 16.3335C3.47015 16.7553 2.89653 16.9927 2.29813 16.9945H1.5055V16.2018C1.50473 15.9052 1.56282 15.6113 1.6764 15.3372C1.78997 15.0632 1.95678 14.8144 2.16716 14.6052L11.4582 5.31393L13.1896 7.04527L3.8947 16.3335ZM16.1373 4.08995L14.2509 5.97711L12.5196 4.24577L14.4067 2.35861C14.6363 2.12902 14.9477 2.00003 15.2724 2.00003C15.4332 2.00003 15.5924 2.0317 15.7409 2.09322C15.8894 2.15475 16.0244 2.24492 16.138 2.35861C16.2517 2.47229 16.3419 2.60725 16.4034 2.75578C16.4649 2.90431 16.4966 3.06351 16.4966 3.22428C16.4966 3.38505 16.4649 3.54424 16.4034 3.69277C16.3419 3.84131 16.2517 3.97627 16.138 4.08995H16.1373Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0301ced71eb0e873fe18ce54ec7eee5f.svg";
export { ForwardRef as ReactComponent };